var BufferStatusView = require('bufferstatusview');

var urlUtil = require('../../lib/url.es6');
var uriTemplates = require('uri-templates');


var ServerLogStatusView = BufferStatusView.extend({
    events: $.extend({}, BufferStatusView.prototype.events, {
        'buttonClick button.reconnect': 'clickReconnect',
        'buttonClick button.disconnect': 'clickDisconnect'
    }),
    clickReconnect: function (e) {
        this.model.connection.reconnect();
        return false;
    },
    clickDisconnect: function (e) {
        this.model.connection.disconnect();
        return false;
    },
    render: function () {
        BufferStatusView.prototype.render.apply(this, arguments);
        
        this.host = $('<span class="host">');
        this.title.append(this.host);
        
        var identity = $('<div class="identity">');
        
        this.nick = $('<span class="nick">');
        this.name = $('<span class="realname">');
        identity.append(this.nick).append(' ').append(this.name);
        
        $(this.el).append(identity);
        
        return this;
    },
    renderLabel: function () {
        this.label.html(this.formatter.render(this.model.connection.getTitle()));
        if (this.model.connection.isSlack()) {
            this.label.prepend('<i class="fa fa-slack" title="Slack workspace">');
        } else if (this.model.connection.isSSL()) {
            this.label.prepend('<i class="fa fa-shield" title="Secure connection">');
        } else {
            this.label.prepend('<i class="fa fa-globe">');
        }
        var icon = this.model.connection.getServerIcon();
        if (icon && this.model.inlineImagesAllowed()) {
            var size = 32;
            var iconTemplate = urlUtil.toHttps(icon);
            var url_1x = uriTemplates(iconTemplate).fill({
                size: size
            });
            var imgAttribs = {
                'class': 'serverIcon',
                width: size,
                height: size,
                src: url_1x
            };
            if (url_1x != iconTemplate) {
                imgAttribs.srcset = url_1x + ' 1x, ' + uriTemplates(iconTemplate).fill({
                    size: size * 2
                }) + ' 2x';
            }
            var iconHtml = '<img' + this.formatter.makeAttributes(imgAttribs) + '>';
            this.label.prepend(iconHtml);
        }
        return this;
    },
    renderConnectionDetails: function () {
        this.host.text(this.model.connection.getHost());
        this.nick.text(this.model.connection.getNick());
        this.name.html(this.formatter.renderLinkify(this.model.connection.get('realname')));
        this.renderLabel();
    },
    renderButtons: function () {
        BufferStatusView.prototype.renderButtons.apply(this);
        this.appendButton('edit', 'Edit');
        this.appendButton('reconnect', 'Reconnect');
        this.appendButton('disconnect', 'Disconnect');
        
        this.appendOptionsButton();
    }
});

module.exports = ServerLogStatusView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/serverlogstatusview.js
// module id = /KSs
// module chunks = 1